import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/store';
import { fetchPermissions, selectAuthPhase, selectToken } from '@/pages/auth/authSlice';
import { setRouteList } from '@/pages/configuration/routeSlice';
import type { AppDispatch } from '@/store/store';

/**
 * Dispatches the fetchPermissions thunk exactly once after OIDC bootstrap
 * transitions phase to 'abp-loading'. Also dispatches setRouteList to the
 * legacy routeSlice for backward compatibility with existing consumers.
 */
export function useAbpPermissions(): void {
  const dispatch: AppDispatch = useAppDispatch();
  const phase = useAppSelector(selectAuthPhase);
  const token = useAppSelector(selectToken);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (phase === 'abp-loading' && token && !hasFetched.current) {
      hasFetched.current = true;
      dispatch(fetchPermissions())
        .unwrap()
        .then((payload) => {
          // Sync to legacy routeSlice for existing consumers (~40 files)
          dispatch(
            setRouteList({
              currentUserAuthList: payload.currentUserAuthList,
              currentUserRoutesList: payload.currentUserRoutesList,
            })
          );
        })
        .catch(() => {
          // Phase transitions to 'error' via rejected case in authSlice
        });
    }
  }, [phase, token]);
}
